import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import moment from "moment";
import { DATE_FORMAT } from "../../constants";
import resmiRuhsatBasvuruSayilari from "../../services/resmiRuhsatBasvuruSayilari";
import belgeTuruVeDurumunaGoreResmiBasvuruListesi from "../../services/belgeTuruVeDurumunaGoreResmiBasvuruListesi";
import useColumns from "../../hooks/useColumns";
import { Table, Card, Row, Col, Drawer,message, Modal, Spin,Form, Input,InputNumber,Select, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined, SearchOutlined, OrderedListOutlined ,FileExcelOutlined} from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import ExcelExport from './../ExcelExport';
import basvuruDenetimSonucKriteriGuncelle from "../../services/basvuruDenetimSonucKriteriGuncelle";
import getBasvuruDenetimSonucKriterList from "../../services/basvuruDenetimSonucKriterList";
import { SaveOutlined } from '@ant-design/icons';
const { Option } = Select;

const parsed = queryString.parse(history.location.search);


function onChange(value, key, record) {
  record[key] = value;
  console.log('changed', value);
}

const DenetimSonuclariForm = () => {
  const [form] = Form.useForm();
  const [selectionType, setSelectionType] = useState('checkbox');
  const [editingKey, setEditingKey] = useState('');
  const [spining, setSpining] = useState(false);
  const [visible, setVisible] = useState(false);
  const [basvuruDenetimSonucKriterList,setBasvuruDenetimSonucKriterList]= useState([]);
  const basvuruId = parseInt(parsed.basvuruId);
  const originData = [];
  const [dates, setDates] = useState([moment(), moment()]);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  let [selectedRowKeys, setSelectedRowKeys] = useState([]);


  useEffect(() => {
    getBasvuruDenetimSonucKriterList(basvuruId).then(res => {
      var newArray=[];
      for(var i=0;i<res.data.result.length;i++){
        if(!newArray.find(x=>x.objectId==res.data.result[i].objectId))
        {
          newArray.push(res.data.result[i]);
        }
        }
      setBasvuruDenetimSonucKriterList(newArray);
    });
    setVisible(true);
    setSpining(false);
    setQueryDates(dates);
  }, []);

  // "objectId": 12,
  // "denetimKriteriId": 3,
  // "denetimKriteriAdi": "Temel Su Yalıtımı Kontrolü",
  // "denetimKriteriAciklama": "Grobeton, Membran, Koruma Betonu",
  // "denetimKriteriSonucId": 1,
  // "denetimKriteriSonucAdi": "Uygun",
  // "aciklama": null

  const columns = [
    {
      title: 'Denetim Kriteri',
      dataIndex: 'denetimKriteriAdi',
      width: '25%',
      editable: true,
    },
    {
      title: 'Denetim Kriteri Açıklama',
      dataIndex: 'denetimKriteriAciklama',
      width: '25%',
      editable: true,
    },
          {
      title: 'Sonuç',
      dataIndex: 'denetimKriteriSonucId',
      width: '15%',
      key: 'denetimKriteriSonucId',
      render: (text, record, value) => (
        <div>
       <Select defaultValue={record.denetimKriteriSonucId != null ? record.denetimKriteriSonucId.toString() : "0"}  onChange={value => onChange(value, 'denetimKriteriSonucId', record)} style={{ width: 120 }}>
      <Option value="0">Seçiniz</Option>
      <Option value="1">Uygun</Option>
      <Option value="2">Uygun Değil</Option>
      <Option value="3">Projede Yok</Option>
    </Select>
        </div>
      )
    },
    ,
    {
      title: 'Açıklama',
      dataIndex: 'aciklama',
      width: '20%',
      key: 'aciklama',
      render: (text, record, value) => (
        <div>
          <Input
            defaultValue={record.aciklama}
            onChange={value => onChange(value.currentTarget.value, 'aciklama', record)} 
          />
        </div>
      )
    }
  ];

  const success = (text) => {
    message.success(text);
  };
  const error = (text) => {
    message.error(text);
  };

const denetimSonuclariOnayla = () => {
  setSpining(true);
  var selectedRows = basvuruDenetimSonucKriterList;
  var requestModel = {};
  if (selectedRows.length > 0) {
      requestModel.BasvuruId = basvuruId;
    requestModel.RequestDenetimKriteri = [];
    for (var i = 0; i < selectedRows.length; i++) {

        if(selectedRows[i].denetimKriteriSonucId=="2" && (selectedRows[i].aciklama=='' || selectedRows[i].aciklama==null))
        {
          message.warning("Denetim kriteri sonucu uygun değilse açıklama alanı doldurulmalıdır.");
          setSpining(false);
          return;          
        }
        requestModel.RequestDenetimKriteri.push({
          "ObjectId": selectedRows[i].objectId,
          "DenetimKriteriId": selectedRows[i].denetimKriteriId,
          "DenetimKriteriSonucId": selectedRows[i].denetimKriteriSonucId !="0" ? parseInt(selectedRows[i].denetimKriteriSonucId) : null,
          "Aciklama": selectedRows[i].aciklama
        });
      }
        //TODO Metod çağrılacak
        basvuruDenetimSonucKriteriGuncelle(requestModel).then(res => { res.data.success ? success('İşlem başarı ile tamamlandı.') : error(res.data.message); setSpining(false); })
        .catch(ex => {
          setSpining(false);
        })
      window.parent.location.reload(); 
    }

    
  setSpining(false);
}


  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
  style={{ margin: "20px" }}
  title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Denetim Sonuçları Formu</h4>}
  className="ant-card-head-title-large">
    <Row gutter={16}>
          {visible &&
              <Table  scroll={{ x: 1500, y: 500 }} pagination={false}  rowKey={"objectId"} bordered dataSource={basvuruDenetimSonucKriterList}  
                columns={columns}
                title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3>
                </div>}
                onChange={
                  (pagination, filters, sorter, extra) => {
                    if (extra.currentDataSource.length < originData.length) {
                    }
                    else {
                    }
                  }
                }
              />
          }
        </Row>
        <Row gutter={16}>{
          <Col
          span={24}
          style={{
            textAlign: 'right',
          }}
          >
        <Button
          onClick={denetimSonuclariOnayla}
          type="primary"
          icon={<SaveOutlined/>}
          style={{
            marginBottom: 16,
            marginTop:8
          }}
        >
          Kaydet
        </Button>
        </Col>
        }
        </Row>
  </Card>
  </Spin>

}
  export default DenetimSonuclariForm;